import React, { useState } from 'react';
import CryptoJS from 'crypto-js'; // Import crypto-js for hashing
import ContactRequestsTable from './pages/ContactRequestsTable';
import './PrivateRoute.css';  // Import custom CSS

const password = '3a8a7ffb4f126d98b6f61fc80812e96b71b7d63abed61e1f4a06e2e94f407c9a'; // Replace with your hashed password (use a hashed version of the password)
const correctPasswordHash = CryptoJS.SHA256(password).toString(CryptoJS.enc.Base64);

const PrivateRoute = ({ children }) => {
  const [password, setPassword] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handlePasswordChange = (e) => setPassword(e.target.value);

  const handlePasswordSubmit = (e) => {
    e.preventDefault();
    const hash = CryptoJS.SHA256(password).toString(CryptoJS.enc.Base64);

    if (hash === correctPasswordHash) {
      setIsAuthenticated(true);
      setErrorMessage('');
    } else {
      setErrorMessage('Incorrect password');
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="password-form">
        <div className="form-container">
          <form onSubmit={handlePasswordSubmit}>
            <div className="form-group">
              <input
                type="password"
                value={password}
                onChange={handlePasswordChange}
                placeholder="Enter Password"
                className="form-control"
              />
            </div>
            {errorMessage && <div className="error-message">{errorMessage}</div>}
            <button type="submit" className="submit-button">
              Submit
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="authenticated-content">
      <h2>Data from Firebase:</h2>
      <ContactRequestsTable />
    </div>
  );
};

export default PrivateRoute;
